"use client";

import { useEffect } from "react";
import { trackAppInsightsException } from "@/lib/app-insights-client";

/** Forward a Next.js route error boundary crash to App Insights once on mount. */
export function useTrackAppInsightsException(
  error: Error,
  digest?: string
): void {
  useEffect(() => {
    trackAppInsightsException(
      error,
      digest
        ? { digest, source: "next_error_boundary" }
        : { source: "next_error_boundary" }
    );
  }, [error, digest]);
}
